import { css } from "@emotion/react";

import { fontSize } from "~/client/styles/emotion/mixins/fontSize";
import tokens from "~/packages/design-tokens/dist/tokens";

export const linkCss = css({
  padding: "6px 0",
  width: "100%",
  display: "block",
  textDecoration: "none",
  color: tokens.color.text.primary.default.value,
  fontSize: fontSize(14).fontSize,
  "&:link": {
    color: tokens.color.text.primary.default.value,
  },
  "&:active": {
    color: tokens.color.text.primary.default.value,
  },
  "&:visited": {
    color: tokens.color.text.primary.default.value,
  },
  "&:hover": {
    textDecoration: "none",
    color: tokens.color.text.primary.default.value,
  },
});
